// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fe35c633","453":"0e0de197","455":"1b7a8418","977":"bde693b0"}[chunkId] + ".chunk.js";
};